import { AxiosResponse } from "axios";
import { http } from "../../../utils";

export type PaymentRegisterFilterType =
  | "ITEMS_GIVEN"
  | "ITEMS_TAKEN"
  | "TDS_ONLY";

export const DEFAULT_PAYMENT_REGISTER_FILTER: PaymentRegisterFilterType =
  "ITEMS_GIVEN";

export interface PaymentListDto {
  id: number;
  partyName: string;
  note?: string;
  refNo?: string;
  partyId: number;
  siteAddress: string;
  siteId: number;
  paymentDate: string | Date;
  createDate: string | Date;
  amount: number;
  type?: string;
  tdsAmount?: number;
  tdsRate?: number;
  tdsSection?: string;
}

export interface PaymentListResponse {
  success: boolean;
  data: PaymentListDto[];
  message?: string;
}

function buildPaymentListQueryParams(
  startDate?: string,
  endDate?: string,
  partyId?: string,
  paymentType: PaymentRegisterFilterType = DEFAULT_PAYMENT_REGISTER_FILTER
): string[] {
  const params: string[] = [];

  if (startDate && endDate) {
    params.push(`from=${startDate}`);
    params.push(`to=${endDate}`);
  }

  if (partyId) {
    params.push(`party_id=${partyId}`);
  }

  params.push(`payment_type=${paymentType}`);

  return params;
}

export function fetchPaymentList(
  startDate?: string,
  endDate?: string,
  partyId?: string,
  paymentType: PaymentRegisterFilterType = DEFAULT_PAYMENT_REGISTER_FILTER
): Promise<AxiosResponse> {
  let url = "/payment/pvt/list";
  const params = buildPaymentListQueryParams(
    startDate,
    endDate,
    partyId,
    paymentType
  );

  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }

  return http.get(url).then((response: AxiosResponse) => response);
}

export function fetchPaymentsPdf(
  startDate?: string,
  endDate?: string,
  partyId?: string,
  paymentType: PaymentRegisterFilterType = DEFAULT_PAYMENT_REGISTER_FILTER
) {
  let url = "/payment/pvt/list_pdf";
  const params = buildPaymentListQueryParams(
    startDate,
    endDate,
    partyId,
    paymentType
  );

  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }

  return http.get(url).then((response: AxiosResponse) => response.data);
}

export function fetchPaymentsExcel(
  startDate?: string,
  endDate?: string,
  partyId?: string,
  paymentType: PaymentRegisterFilterType = DEFAULT_PAYMENT_REGISTER_FILTER
) {
  let url = "/payment/pvt/list_excel";
  const params = buildPaymentListQueryParams(
    startDate,
    endDate,
    partyId,
    paymentType
  );

  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }

  return http.get(url).then((response: AxiosResponse) => response.data);
}
